<app-user-header class="d-md-none"></app-user-header> 

<div class="wrapperi pb-4 ">
    <div class="col-12 ps-2 pe-2 m-0 pt-4 row">
        <div class="col-2"></div>
        <div class="col-8">
            <app-top-banner [backgroundClass]="'banner-green-bg'" [title]="topic_title" [buttonText]="'Lisää työpaikka'" [imgSrc]="'../../assets/icons/dashboard_icon.svg'"  [subtitle]="'OSallistu keskusteluun polttavimmista aiheista!'"></app-top-banner>

        </div>
        <div class="col-2"></div>
    </div>
    <div class="col-12 ps-2 pe-2">
        <div class="col-12 row m-0">
            <div class="col-2"></div>
            <div class="col-8" id="scroll-area" (scroll)="checkBottom()">
                <div class="text-center" *ngIf="has_before">
                    <button class="btn btn-formed-main-blue">Lataa aikaisemmat</button>
                </div>
                <div class="card p-3 mt-2"  *ngFor="let data of topics">
                    <div class="col-12 d-flex justify-content-between">
                        <div class="d-flex justify-content-start">
                            <div class="">
                                <img class="rounded-circle" src="https://forum.formed.fi{{data.avatar_template | generateAvatarImageURL}}" alt="">
                            </div>
                            <div class="">
                                <p class="mb-0 ms-3">{{data['username']}}</p>
                                <p class="mb-0 ms-3">{{data['user_title']}}</p>
                            </div>
                        </div>
                        <div class="d-flex justify-content-end">
                            <p><i class="fal fa-calendar-alt me-2"></i>{{data['created_at'] | formateDate}}</p>
                        </div>

                    </div>
                    <div [innerHTML]="data.cooked"></div>
                    <div class="d-flex justify-content-between">
                        <p><i class="fal fa-comments me-2"></i>{{data['posts_count']}}</p>
                        <p (click)="postActions(2)"><i class="fal fa-heart me-2"></i>{{data['actions_summary'][0]['count'] ? data['actions_summary'][0]['count'] : 0}} tykkäystä</p>
                        <p><i class="fal fa-flag-alt me-2"></i>Ilmianna</p>
    
                    </div>                </div>
                <button class="btn btn-formed-main-blue">Vastaa</button>
            </div>
            <div class="col-2"></div>
        </div>


    </div>
  
</div>
